//src/components/ContentBlocks.js
import React from 'react';
import './ContentBlocks.css'; // Use this for custom styles
import { useLocation } from 'react-router-dom';

const ContentBlocks = ({ heading, subheading, blocks }) => {

  const location = useLocation(); // Get current location

  // Default Width for block item
  let blockWidth;

  // Conditionally update width based on the route
   if (location.pathname === '/digital-outreach') {
      blockWidth = 'calc(33.33% - 1px)';
  }

  return (
    <section className="content-blocks">
      {/* Section Heading */}
      <div className="content-header">
        <h2>{heading}</h2>
        {subheading && <p className="subheading">{subheading}</p>}
      </div>
      
      {/* Blocks Grid */}
      <div className="blocks-grid">
        {blocks.map((block, index) => (
          <div key={index} className="block-item" style={{ width: blockWidth }}>
            <h3>{block.blockHeading}</h3>
            <hr />
            <p>{block.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ContentBlocks;
